const B_1 = [
    {
        title: '异议或投诉管理',
        path: '/bidding/projectflow/dingbiao/cjyygl/list'
    }
]
export default {
    path: 'cjyygl',
    component: () => import(/*webpackChunkName: 'bidding-ding-cjyygl'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/cjyygl/list'),
            meta: {
                title: '异议或投诉管理',
                bread: B_1
            },
        },
         {
             path:"edit",
             component: () => import('@views/bidding/views/project-flow/ding/cjyygl/edit'),
             meta: {
                 title: '受理异议或投诉信息',
                 bread: B_1
             },
         },
         {
             path:"detail",
             component: () => import('@views/bidding/views/project-flow/ding/cjyygl/detail'),
             meta: {
                 title: '异议或投诉管理详细信息',
                 bread: B_1
             },
         },
    ]
}